(function () {
  var bar = document.getElementById('per-tab-bar');
  var panels = document.querySelectorAll('.per-tab-panel');
  if (!bar) return;
  bar.addEventListener('click', function (e) {
    var li = e.target.closest('li[data-pertab]');
    if (!li) return;
    var idx = li.getAttribute('data-pertab');
    bar.querySelectorAll('li').forEach(function (t) { t.classList.remove('per-active'); });
    panels.forEach(function (p) { p.style.display = 'none'; });
    li.classList.add('per-active');
    var panel = document.getElementById('per-panel-' + idx);
    if (panel) panel.style.display = 'block';
  });
})();


(function () {
  var wrap = document.getElementById('per-gift-wrap');
  if (!wrap) return;
  wrap.addEventListener('click', function (e) {
    var title = e.target.closest('.acc__title');
    if (!title) return;
    var card = title.closest('.acc__card');
    var panel = card ? card.querySelector('.acc__panel') : null;
    var isOpen = title.classList.contains('per-open');
    wrap.querySelectorAll('.acc__panel').forEach(function (p) {
      if (p !== panel) p.style.display = 'none';
    });
    wrap.querySelectorAll('.acc__title').forEach(function (t) {
      if (t !== title) t.classList.remove('per-open');
    });
    if (isOpen) {
      title.classList.remove('per-open');
      if (panel) panel.style.display = 'none';
    } else {
      title.classList.add('per-open');
      if (panel) panel.style.display = 'block';
    }
    e.preventDefault();
  });
})();

(function () {
  'use strict';

  var IMGBB_KEY = '61c5d393d2488370dbc4d6cef92ec9a6';
  var STORAGE_KEY = 'personalization_labels';

  /*
   * uploadedPhotoUrls is keyed by SECTION KEY (e.g. 'photo', 'mug')
   * so each section keeps its own photo independently.
   */
  var uploadedPhotoUrls = {};
  var buttonListenerAttached = false;

  /*
   * photoLoaderId maps each section to its own <input type="file"> element.
   * Sections without a photo upload have photoLoaderId: null.
   */
  var ALL_CFG = [
    { key: 'wine', canvasId: 'myCanvas', msgId: 'winemessage', tab: 1, x: 'wine_x', y: 'wine_y', photoLoaderId: null },
    { key: 'beer', canvasId: 'myCanvas_1', msgId: 'beermessage', tab: 2, x: 'wine_x', y: 'wine_y', photoLoaderId: null },
    { key: 'choco', canvasId: 'myCanvas_2', msgId: 'chocomessage', tab: 3, x: 'wine_x', y: 'wine_y', photoLoaderId: null },
    { key: 'candle', canvasId: 'myCanvas_3', msgId: 'candlemessage', tab: 4, x: 'candle_x', y: 'candle_y', photoLoaderId: null },
    { key: 'photo', canvasId: 'myCanvas_11', msgId: 'photomessage', tab: 5, x: 'wine_x', y: 'wine_y', photoLoaderId: 'imageLoader' },
    { key: 'mug', canvasId: 'myCanvas_4', msgId: 'mugmessage', tab: 6, x: 'mug_x', y: 'mug_y', photoLoaderId: 'imageLoader2' },
    { key: 'beer_stein', canvasId: 'myCanvas_5', msgId: 'beersteinmessage', tab: 7, x: 'beer_stein_x', y: 'beer_stein_y', photoLoaderId: 'imageLoader3' },
    { key: 'water_bottle', canvasId: 'myCanvas_6', msgId: 'waterbottlemessage', tab: 8, x: 'water_bottle_x', y: 'water_bottle_y', photoLoaderId: 'imageLoader4' },
    { key: 'travel_mug', canvasId: 'myCanvas_7', msgId: 'travelmugmessage', tab: 9, x: 'travel_mug_x', y: 'travel_mug_y', photoLoaderId: 'imageLoader5' }
  ];

  var LABELS = {
    wine: 'Wine Label',
    beer: 'Beer Label',
    choco: 'Chocolate Label',
    candle: 'Candle Label',
    photo: 'Photo Label',
    mug: 'Mug Label',
    beer_stein: 'Beer Stein Label',
    water_bottle: 'Water Bottle Label',
    travel_mug: 'Travel Mug Label'
  };

  /* ── Helpers ─────────────────────────────────────────────── */

  function getCfg(key) {
    for (var i = 0; i < ALL_CFG.length; i++) {
      if (ALL_CFG[i].key === key) return ALL_CFG[i];
    }
    return null;
  }

  function switchToTab(num) {
    var bar = document.getElementById('per-tab-bar');
    if (!bar) return;
    bar.querySelectorAll('li').forEach(function (li) { li.classList.remove('per-active'); });
    document.querySelectorAll('.per-tab-panel').forEach(function (p) { p.style.display = 'none'; });
    var li = bar.querySelector('li[data-pertab="' + num + '"]');
    var panel = document.getElementById('per-panel-' + num);
    if (li) li.classList.add('per-active');
    if (panel) panel.style.display = 'block';
  }

  function getCheckedSections() {
    var out = [];
    ALL_CFG.forEach(function (c) {
      if (document.querySelector("input[type='checkbox'][name='" + c.key + "_id']:checked")) {
        out.push(c.key);
      }
    });
    return out;
  }

  /* ── Session storage ─────────────────────────────────────── */

  function saveToStorage(section, variantId, props) {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      d[section] = { variantId: variantId, properties: props };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d));
    } catch (e) { }
  }

  function removeFromStorage(section) {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      delete d[section];
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d));
    } catch (e) { }
  }

  function getFromStorage() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; }
  }

  function clearStorage() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { }
  }

  /* ── Progress popup ──────────────────────────────────────── */

  function showProgress(txt) {
    var p = document.getElementById('per-progress-popup');
    var b = document.getElementById('per-progress-bar');
    var t = document.getElementById('per-progress-text');
    if (p) p.style.display = 'flex';
    if (b) b.style.width = '0%';
    if (t) t.textContent = txt || 'Loading…';
  }

  function setProgress(pct) {
    var b = document.getElementById('per-progress-bar');
    if (b) b.style.width = Math.min(100, Math.max(0, pct)) + '%';
  }

  function hideProgress() {
    var p = document.getElementById('per-progress-popup');
    if (p) p.style.display = 'none';
  }

  /* ── Image upload ────────────────────────────────────────── */

  function uploadFile(file) {
    return new Promise(function (resolve, reject) {
      if (!file) return resolve(null);
      var fd = new FormData();
      var xhr = new XMLHttpRequest();
      fd.append('image', file);
      xhr.open('POST', 'https://api.imgbb.com/1/upload?key=' + IMGBB_KEY, true);
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) setProgress(Math.min(99, Math.round(e.loaded / e.total * 100)));
      };
      xhr.onload = function () {
        try {
          var r = JSON.parse(xhr.responseText);
          resolve(r && r.data && r.data.url ? r.data.url : null);
        } catch (er) { reject(er); }
      };
      xhr.onerror = function () { reject(new Error('upload failed')); };
      xhr.send(fd);
    });
  }

  function uploadDataURL(dataURL) {
    if (!dataURL) return Promise.resolve(null);
    var fd = new FormData();
    fd.append('image', dataURL.split(',')[1]);
    return fetch('https://api.imgbb.com/1/upload?key=' + IMGBB_KEY, { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j && j.data && j.data.url ? j.data.url : null; })
      .catch(function () { return null; });
  }

  /* ── Canvas rendering ────────────────────────────────────── */

  var FONT_MAP = {
    mug: '12px Arial',
    beer_stein: '12px Arial',
    travel_mug: '11px Arial',
    candle: '12px Arial',
    water_bottle: '10px Arial'
  };

  function wrapText(ctx, text, x, y, maxW, lh) {
    var words = (text || '').split(' ');
    var line = '';
    var lines = [];
    words.forEach(function (w) {
      var t = line + w + ' ';
      if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w + ' '; }
      else line = t;
    });
    lines.push(line);
    var sy = y - ((lines.length - 1) * lh) / 2;
    lines.forEach(function (l) {
      ctx.textAlign = 'center';
      ctx.fillText(l, x, sy);
      sy += lh;
    });
  }

  function updateCanvas(src, msg, ctx, canvas, x, y, section, cb) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      ctx.font = FONT_MAP[section] || '18px Arial';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      wrapText(ctx, msg, x, y, canvas.width - 40, 30);
      if (cb) cb();
    };
    img.src = src;
  }

  function safeCanvas(id) {
    var el = document.getElementById(id);
    return el ? { canvas: el, ctx: el.getContext('2d') } : null;
  }

  /* ── Cart badge & drawer ─────────────────────────────────── */

  function updateBadge(n) {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart) hdtCart.setAttribute('data-count', n);
    var sels = [
      'hdt-cart-count',

      '.hdt-mini-cart__count', '.hdt-header__cart-count',

      '[data-cart-count]', '[data-header-cart-count]',

      '#cart-icon-bubble', '.cart-count-bubble span'
    ];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
      });
    });
  }

  function openHDTCart() {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart && typeof hdtCart.open === 'function') {
      hdtCart.open();
      return;
    }
    var triggerSels = [
      '[aria-controls="CartDrawer"]',
      '[data-cart-drawer-trigger]',
      '.hdt-header__cart',
      '.hdt-header__icon--cart',
      'button[data-cart]',
      'a[href="/cart"].hdt-header__icon'
    ];
    for (var i = 0; i < triggerSels.length; i++) {
      var el = document.querySelector(triggerSels[i]);
      if (el && !el.closest('#CartDrawer')) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        var hdtCart = document.querySelector('hdt-cart-drawer');
        if (!hdtCart) { openHDTCart(); return; }
        if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
        if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
        var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
        fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[sectionId] || null;
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-items-component');
              var live = document.querySelector('cart-items-component');
              if (fresh && live) live.replaceWith(fresh);
            }
            openHDTCart();
          })
          .catch(function () { openHDTCart(); });
      })
      .catch(function () { openHDTCart(); });
  }

  function wirePhotoInputs() {
    ALL_CFG.forEach(function (cfg) {
      if (!cfg.photoLoaderId) return;
      var el = document.getElementById(cfg.photoLoaderId);
      if (!el) return;

      el.addEventListener('change', function () {
        var file = el.files && el.files[0];
        if (!file) return;
        showProgress('Uploading photo…');
        uploadFile(file)
          .then(function (url) {
            setProgress(100);
            hideProgress();
            if (url) {
              uploadedPhotoUrls[cfg.key] = url;
            } else {
              alert('Photo upload failed. Please try again.');
            }
          })
          .catch(function () {
            hideProgress();
            alert('Photo upload error.');
          });
      });
    });
  }

  function collectPhotoForSection(sectionKey) {
    if (uploadedPhotoUrls[sectionKey]) {
      return Promise.resolve(uploadedPhotoUrls[sectionKey]);
    }
    var cfg = getCfg(sectionKey);
    if (cfg && cfg.photoLoaderId) {
      var el = document.getElementById(cfg.photoLoaderId);
      if (el && el.files && el.files[0]) {
        return uploadFile(el.files[0]).then(function (url) {
          if (url) uploadedPhotoUrls[sectionKey] = url;
          return url || null;
        });
      }
    }
    return Promise.resolve(null);
  }

  /* ── Validation modal ────────────────────────────────────── */

  function showModal(missing, onConfirm) {
    var modal = document.getElementById('per-validation-modal');
    var list = document.getElementById('per-modal-missing-list');
    var okBtn = document.getElementById('per-modal-ok-btn');
    var closeX = document.getElementById('per-modal-close-x');
    if (!modal) return;

    list.innerHTML = '';
    missing.forEach(function (s) {
      var li = document.createElement('li');
      li.textContent = LABELS[s] || s;
      list.appendChild(li);
    });

    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.classList.add('is-open');

    function close() {
      modal.classList.remove('is-open');
      okBtn.removeEventListener('click', ok);
      closeX.removeEventListener('click', close);
      modal.removeEventListener('click', backdrop);
      /* Dispatch closed event so callers can reset modal text */
      modal.dispatchEvent(new CustomEvent('per:modal:closed'));
    }
    function ok() { close(); if (onConfirm) onConfirm(); }
    function backdrop(e) { if (e.target === modal) close(); }

    okBtn.addEventListener('click', ok);
    closeX.addEventListener('click', close);
    modal.addEventListener('click', backdrop);
  }

  /* ── Highlight tab error indicators for noLabel sections ─── */
  function highlightTabErrors(sections) {
    sections.forEach(function (section, idx) {
      var cfg = getCfg(section);
      var tabLi = cfg ? document.querySelector('#per-tab-bar li[data-pertab="' + cfg.tab + '"]') : null;
      if (tabLi) tabLi.classList.add('per-tab-err');
      if (idx === 0 && cfg) switchToTab(cfg.tab);

      /* Auto-clear the tab error once the user selects a label */
      var cbs = document.querySelectorAll("input[type='checkbox'][name='" + cfg.key + "_id']");
      cbs.forEach(function (cb) {
        cb.addEventListener('change', function clearErr() {
          if (cb.checked && tabLi) tabLi.classList.remove('per-tab-err');
          cb.removeEventListener('change', clearErr);
        });
      });
    });
  }

  function highlightErrors(missing) {
    document.querySelectorAll('.per-tab-err').forEach(function (el) { el.classList.remove('per-tab-err'); });
    document.querySelectorAll('.per-msg-error').forEach(function (el) { el.classList.remove('per-msg-error'); });
    document.querySelectorAll('.per-msg-error-hint').forEach(function (el) { el.remove(); });

    missing.forEach(function (section, idx) {
      var cfg = getCfg(section);
      var msgEl = cfg ? document.getElementById(cfg.msgId) : null;
      if (!msgEl) return;

      var tabLi = document.querySelector('#per-tab-bar li[data-pertab="' + cfg.tab + '"]');
      if (tabLi) tabLi.classList.add('per-tab-err');

      if (idx === 0) {
        switchToTab(cfg.tab);
        setTimeout(function () { msgEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
      }

      msgEl.classList.add('per-msg-error');
      if (!msgEl.parentElement.querySelector('.per-msg-error-hint')) {
        var hint = document.createElement('span');
        hint.className = 'per-msg-error-hint';
        hint.textContent = '⚠ Please enter your personalisation message';
        msgEl.parentElement.insertBefore(hint, msgEl.nextSibling);
      }

      msgEl.addEventListener('input', function clear() {
        msgEl.classList.remove('per-msg-error');
        if (tabLi) tabLi.classList.remove('per-tab-err');
        var h = msgEl.parentElement.querySelector('.per-msg-error-hint');
        if (h) h.remove();
        msgEl.removeEventListener('input', clear);
      });
    });
  }

  /* ── Section-level logic (checkbox + textarea + canvas) ─── */

  function handleSection(cfg, checkboxes, msgInput) {
    var canvas = safeCanvas(cfg.canvasId);
    var suppressChange = false;

    function getImgSrc() {
      var cb = document.querySelector("input[type='checkbox'][name='" + cfg.key + "_id']:checked");
      if (!cb) return null;
      var img = cb.parentElement.querySelector('img');
      return img ? img.src : null;
    }

    function renderPreview() {
      var src = getImgSrc();
      if (!src || !canvas) return;
      var x = parseInt((document.getElementById(cfg.x) || {}).value || '100', 10);
      var y = parseInt((document.getElementById(cfg.y) || {}).value || '150', 10);
      updateCanvas(src, (msgInput.value || '').trim(), canvas.ctx, canvas.canvas, x, y, cfg.key, null);
    }

    function syncStorage(variantId) {
      var props = {};
      props[cfg.key + ' Message'] = (msgInput.value || '').trim();
      if (cfg.key === 'wine') {
        var wt = document.getElementById('wine_type');
        props['Wine Type'] = wt ? wt.value : '';
      }
      saveToStorage(cfg.key, variantId, props);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (suppressChange) return;
        if (!cb.checked) {
          removeFromStorage(cfg.key);
          if (canvas) canvas.ctx.clearRect(0, 0, canvas.canvas.width, canvas.canvas.height);
          return;
        }
        suppressChange = true;
        checkboxes.forEach(function (o) { if (o !== cb) o.checked = false; });
        suppressChange = false;
        syncStorage(cb.value);
        renderPreview();
        if (msgInput && !msgInput._perBound) {
          msgInput._perBound = true;
          msgInput.addEventListener('input', function () {
            var d = getFromStorage();
            if (d[cfg.key]) {
              d[cfg.key].properties[cfg.key + ' Message'] = msgInput.value.trim();
              try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch (e) { }
            }
            renderPreview();
          });
        }
      });
    });

    if (cfg.key === 'wine') {
      var wt = document.getElementById('wine_type');
      if (wt) {
        wt.addEventListener('change', function () {
          var d = getFromStorage();
          if (d.wine) {
            d.wine.properties['Wine Type'] = this.value;
            try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch (e) { }
          }
        });
      }
    }
  }

  /* ── Cart intercept ──────────────────────────────────────── */

  function interceptCart() {
    if (buttonListenerAttached) return;
    var btn = document.querySelector('button[name="add"]')
      || document.querySelector('.t4s-product-form__submit')
      || document.querySelector('.product-form__submit')
      || document.querySelector('[data-atc-form] button[type="submit"]');
    if (!btn) return;
    buttonListenerAttached = true;

    btn.addEventListener('click', function (e) {

      /* 1. Which sections have a label selected */
      var active = getCheckedSections();

      /* 2. Which sections have content (message/photo) but NO label selected */
      var noLabel = [];
      ALL_CFG.forEach(function (cfg) {
        var isChecked = !!document.querySelector("input[type='checkbox'][name='" + cfg.key + "_id']:checked");
        if (isChecked) return; // has a label — fine

        var msgEl = document.getElementById(cfg.msgId);
        var hasMsg = msgEl && (msgEl.value || '').trim().length > 0;
        var fileEl = cfg.photoLoaderId ? document.getElementById(cfg.photoLoaderId) : null;
        var hasFile = fileEl && fileEl.files && fileEl.files.length > 0;
        var hasUploadedPhoto = !!uploadedPhotoUrls[cfg.key];

        if (hasMsg || hasFile || hasUploadedPhoto) {
          noLabel.push(cfg.key);
        }
      });

      /* 3. Nothing touched at all — let native submit run */
      if (!active.length && !noLabel.length) return;

      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

      /* 4. Sync storage with current field values */
      var saved = getFromStorage();
      Object.keys(saved).forEach(function (k) {
        if (active.indexOf(k) === -1) delete saved[k];
      });
      active.forEach(function (section) {
        if (!saved[section]) {
          var cb = document.querySelector("input[type='checkbox'][name='" + section + "_id']:checked");
          saved[section] = { variantId: cb ? cb.value : '', properties: {} };
        }
        var cfg = getCfg(section);
        var el = cfg ? document.getElementById(cfg.msgId) : null;
        if (el) saved[section].properties[section + ' Message'] = el.value.trim();
      });
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved)); } catch (er) { }

      /* 5. Which active sections have an empty message */
      var missingMsg = active.filter(function (s) {
        if (s === 'wine') return false;
        return !(saved[s].properties[s + ' Message'] || '').trim();
      });

      /* 6. Modal element refs */
      var modal = document.getElementById('per-validation-modal');
      var title = modal ? modal.querySelector('.per-modal__title') : null;
      var body = modal ? modal.querySelector('.per-modal__body') : null;
      var okBtn = modal ? modal.querySelector('.per-modal__btn') : null;

      var hasBoth = noLabel.length > 0 && missingMsg.length > 0;
      var hasNoLabel = noLabel.length > 0 && missingMsg.length === 0;
      var hasMissingMsg = missingMsg.length > 0 && noLabel.length === 0;

      /* Helper: reset modal text to defaults after it closes */
      function resetOnClose(modalEl) {
        function onClose() {
          if (title) title.textContent = 'Personalisation message missing';
          if (body) body.textContent = 'Please add a message for the selected labels before adding to cart:';
          if (okBtn) okBtn.textContent = 'Add message';
          modalEl.removeEventListener('per:modal:closed', onClose);
        }
        modalEl.addEventListener('per:modal:closed', onClose);
      }

      /* Case A: both problems at once */
      if (hasBoth) {
        if (title) title.textContent = 'Fill the empty fields';
        if (body) body.textContent = 'Please select a label and add a message for:';
        if (okBtn) okBtn.textContent = 'Fill the empty fields';

        var allProblems = noLabel.concat(missingMsg.filter(function (s) { return noLabel.indexOf(s) === -1; }));
        highlightTabErrors(noLabel);
        highlightErrors(missingMsg);
        showModal(allProblems, function () {
          var cfg = getCfg(allProblems[0]);
          if (cfg) switchToTab(cfg.tab);
        });
        resetOnClose(modal);
        return;
      }

      /* Case B: content added but no label selected */
      if (hasNoLabel) {
        if (title) title.textContent = 'Please select a label';
        if (body) body.textContent = 'You\'ve added a message or photo but haven\'t selected a label design for:';
        if (okBtn) okBtn.textContent = 'Select the label';

        highlightTabErrors(noLabel);
        showModal(noLabel, function () {
          var cfg = getCfg(noLabel[0]);
          if (cfg) {
            switchToTab(cfg.tab);
            var cont = document.getElementById('per-panel-' + cfg.tab);
            if (cont) setTimeout(function () { cont.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
          }
        });
        resetOnClose(modal);
        return;
      }

      /* Case C: label selected but message is empty */
      if (hasMissingMsg) {
        if (title) title.textContent = 'Personalisation message missing';
        if (body) body.textContent = 'Please add a message for the selected labels before adding to cart:';
        if (okBtn) okBtn.textContent = 'Add message';

        highlightErrors(missingMsg);
        showModal(missingMsg, function () {
          var cfg = getCfg(missingMsg[0]);
          var el = cfg ? document.getElementById(cfg.msgId) : null;
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { el.focus(); }, 400);
          }
        });
        return;
      }

      /* 7. All valid — proceed to add to cart */
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;">'
        + '<svg style="animation:per-spin 0.8s linear infinite;width:18px;height:18px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">'
        + '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>'
        + '</svg>Adding...</span>';

      if (!document.getElementById('per-spin-style')) {
        var st = document.createElement('style');
        st.id = 'per-spin-style';
        st.textContent = '@keyframes per-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}';
        document.head.appendChild(st);
      }

      function restore() { btn.disabled = false; btn.innerHTML = orig; }

      saved = getFromStorage();
      var keys = Object.keys(saved);

      /* Render canvas previews and upload them */
      var previews = keys.map(function (section) {
        var data = saved[section];
        var msg = (data.properties[section + ' Message'] || '').trim();
        var cfg = getCfg(section); if (!cfg) return Promise.resolve();
        var c = safeCanvas(cfg.canvasId); if (!c) return Promise.resolve();
        var cb = document.querySelector("input[type='checkbox'][name='" + section + "_id']:checked");
        if (!cb) return Promise.resolve();
        var img = cb.parentElement.querySelector('img'); if (!img) return Promise.resolve();
        var x = parseInt((document.getElementById(cfg.x) || {}).value || '100', 10);
        var y = parseInt((document.getElementById(cfg.y) || {}).value || '150', 10);

        return new Promise(function (res) {
          updateCanvas(img.src, msg, c.ctx, c.canvas, x, y, section, function () {
            uploadDataURL(c.canvas.toDataURL('image/webp', 0.5)).then(function (url) {
              if (url) data.properties['Label Preview'] = url;
              res();
            });
          });
        });
      });

      Promise.all(previews)
        .then(function () {
          showProgress('Uploading photos…');
          return Promise.all(
            keys.map(function (section) {
              return collectPhotoForSection(section).then(function (url) {
                if (url) saved[section].properties['Photo Upload'] = url;
              });
            })
          );
        })
        .then(function () {
          hideProgress();
          try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved)); } catch (er) { }

          var items = keys.map(function (s) {
            return { id: saved[s].variantId, quantity: 1, properties: saved[s].properties };
          });

          return jQuery.ajax({
            url: '/cart/add.js', method: 'POST',
            data: { items: items }, dataType: 'json', timeout: 15000
          });
        })
        .then(function () {
          var form = btn.closest('form');
          var formData = new FormData(form);
          return jQuery.ajax({
            url: '/cart/add.js', method: 'POST',
            data: { id: formData.get('id'), quantity: formData.get('quantity') || 1 },
            dataType: 'json'
          });
        })
        .then(function () {
          clearStorage();
          uploadedPhotoUrls = {};
          document.querySelectorAll('input[type="checkbox"][name*="_id"]').forEach(function (cb) {
            cb.checked = false;
          });
          restore();
          refreshCart();
        })
        .catch(function () {
          restore();
          alert('Failed to add items to cart. Please try again.');
        });

    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    wirePhotoInputs();
    interceptCart();
    setTimeout(interceptCart, 1000);

    ALL_CFG.forEach(function (cfg) {
      var cbs = document.querySelectorAll("input[type='checkbox'][name='" + cfg.key + "_id']");
      var msgEl = document.getElementById(cfg.msgId);
      if (cbs.length && msgEl) handleSection(cfg, cbs, msgEl);
    });
  });

})();

